import AssetsMain from '@/assets/image/useCases/tokenizedRWA/assets_main.png'
import '@/assets/scss/global.scss';
import './index.scss'
import { Link } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

const TokenizedRWAHead = () => {
  const isDesktop = useMediaQuery({ minWidth: 769 });
   return (
     <div className={`w-1340 tokenized-RWA-head ${isDesktop?`pt-[120px] pb-[70px]`:`pt-[80px] pb-[40px]`}`}>
       {
         isDesktop ? (
           <div className={`flex items-center `}>
             <div className={`text-[#fff] text-left flex-1 mr-[32px]`}>
               <div className={`tokenized-RWA-head-title text-[64px]`}>
                 Tokenized<br />
                 RWA
               </div>
               <div className={`get-touch-btn mt-[74px]`}>
                 <Link target="_blank" to="https://form.typeform.com/to/IjCOn4nY?typeform-source=vishwanetwork.xyz">
                   <div className={`get-touch-btn-text`}>Get In Touch</div>
                 </Link>
                 <div className={`get-touch-mask`} />
               </div>
             </div>
             <div className={`flex items-center`}>
               <img src={AssetsMain} className={`h-[413px]`} />
             </div>
           </div>
         ) : (
           <div className={`text-center `}>
             <div className={`flex items-center`}>
               <img src={AssetsMain} className={`w-[80%] ml-[10%]`} />
             </div>
             <div className={`text-[#fff] flex-1 mt-[40px]`}>
               <div className={`tokenized-RWA-head-title text-[20px]`}>
                 Tokenized RWA
               </div>
               <div className={`get-touch-btn mt-[74px]`} style={{ margin: '20px auto' }}>
                 <Link target="_blank" to="https://form.typeform.com/to/IjCOn4nY?typeform-source=vishwanetwork.xyz">
                   <div className={`get-touch-btn-text`}>Get In Touch</div>
                 </Link>
                 <div className={`get-touch-mask`} />
               </div>
             </div>

           </div>
         )
       }

     </div>

   )
}

export default TokenizedRWAHead